import { useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { testimonials } from "@/data/siteData";

export function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const visibleCount = 3;
  const maxSlide = Math.max(0, testimonials.length - visibleCount);

  return (
    <section className="py-10 md:py-14 bg-background">
      <div className="container-main">
        {/* Header */}
        <div className="text-center mb-8">
          <span className="section-label">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-3 uppercase">
            A True Extension of Our Clients' Teams
          </h2>
        </div>

        {/* Testimonial Cards — Google Review Style */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {testimonials.slice(currentSlide, currentSlide + visibleCount).map((testimonial, index) => (
            <div
              key={index}
              className="bg-background rounded-2xl p-6 shadow-card border border-border animate-fade-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Top row: avatar + name */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-secondary to-primary flex items-center justify-center text-primary-foreground font-bold text-sm">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-foreground text-sm flex items-center gap-1.5">
                    <span className="text-lg">{testimonial.flag}</span>
                    {testimonial.author}
                  </div>
                  <div className="text-xs text-muted-foreground">{testimonial.company}</div>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-[#FBBC04] text-[#FBBC04]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-foreground text-sm leading-relaxed">
                "{testimonial.quote}"
              </p>
            </div>
          ))}
        </div>

        {/* Carousel dots — wrapped buttons provide a 24x24 hit area for WCAG 2.5.8 target size */}
        <div className="flex justify-center gap-1 mt-8">
          {Array.from({ length: maxSlide + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentSlide(i)}
              className="p-[7px] inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-full"
              aria-label={`Go to testimonial set ${i + 1}`}
              aria-current={i === currentSlide ? 'true' : undefined}
            >
              <span
                aria-hidden="true"
                className={`block w-2.5 h-2.5 rounded-full transition-colors ${
                  i === currentSlide ? 'bg-primary' : 'bg-border'
                }`}
              />
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <Link
            to="/case-studies"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-secondary to-primary text-primary-foreground px-8 py-3 rounded-full font-semibold uppercase text-xs tracking-wide hover:opacity-90 transition-opacity"
          >
            View Our Case Studies
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
